import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, ExternalLink, Home, Calendar, Hash } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatOrderNumber } from '../utils/orderNumber';
export function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderCopied, setOrderCopied] = useState(false);
  const name = searchParams.get('name') || 'חבר';
  const email = searchParams.get('email') || '';
  const orderNumber = searchParams.get('orderNumber') || '';
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderNumber);
    setOrderCopied(true);
    setTimeout(() => setOrderCopied(false), 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white" dir="rtl" data-id="element-1491">
      <Navigation data-id="element-1492" />

      <div className="container mx-auto px-4 py-20" data-id="element-1493">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-1494">
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="flex justify-center mb-8" data-id="element-1495">
            <div className="bg-green-100 rounded-full p-6" data-id="element-1496">
              <CheckCircle className="w-20 h-20 text-green-600" data-id="element-1497" />
            </div>
          </motion.div>

          {/* Thank You Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-center mb-12" data-id="element-1498">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-1499">
              תודה {name}! 🎉
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1500">
              ההרשמה שלך ל-Water Tribe Fest 2026 התקבלה בהצלחה!
            </p>
            <p className="text-lg text-gray-500 mt-2" data-id="element-1501">
              קיבלת אישור למייל: <span className="font-semibold" data-id="element-1502">{email}</span>
            </p>
          </motion.div>

          {/* Order Number Card */}
          {orderNumber && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-indigo-200 mb-8" data-id="element-1503">
              <div className="flex items-center gap-3 mb-4" data-id="element-1504">
                <div className="bg-indigo-100 rounded-full p-2" data-id="element-1505">
                  <Hash className="w-6 h-6 text-indigo-600" data-id="element-1506" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-1507">
                  מספר הזמנה
                </h2>
              </div>

              <p className="text-gray-600 mb-4" data-id="element-1508">
                זהו מספר ההזמנה הייחודי שלך. שמור אותו לצורך התכתבות ואימות
                בכניסה לאירוע.
              </p>

              <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-6 border-2 border-indigo-100" data-id="element-1509">
                <div className="flex items-center justify-between gap-4" data-id="element-1510">
                  <div className="flex-1" data-id="element-1511">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-1512">
                      מספר ההזמנה שלך:
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-indigo-600 tracking-wider" data-id="element-1513">
                      {orderNumber}
                    </p>
                  </div>
                  <button onClick={handleCopyOrderNumber} className="bg-indigo-100 hover:bg-indigo-200 p-4 rounded-xl transition-colors shrink-0" data-id="element-1514">
                    {orderCopied ? <CheckCircle className="w-6 h-6 text-indigo-600" data-id="element-1515" /> : <Copy className="w-6 h-6 text-indigo-600" data-id="element-1516" />}
                  </button>
                </div>
              </div>
            </motion.div>}

          {/* Billing Announcement */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55
        }} className="bg-amber-50 rounded-2xl p-6 md:p-8 shadow-lg border-2 border-amber-300 mb-8" data-id="element-1517">
            <div className="flex items-start gap-4" data-id="element-1518">
              <div className="bg-amber-200 rounded-full p-3 shrink-0 mt-0.5" data-id="element-1519">
                <span className="text-2xl" data-id="element-1520">⚠️</span>
              </div>
              <div data-id="element-1521">
                <h3 className="text-xl md:text-2xl font-black text-amber-900 mb-2" data-id="element-1522">
                  שימו לב! ❤️
                </h3>
                <p className="text-lg font-semibold text-amber-800 leading-relaxed" data-id="element-1523">
                  החיוב יופיע מחברת{' '}
                  <span className="font-black text-amber-950" data-id="element-1524">
                    "אנרצ'י רפואה משלימה"
                  </span>
                  , סכום החיוב יהיה זהה לסכום ההזמנה.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Next Steps */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8" data-id="element-1525">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1526">מה הלאה?</h3>
            <div className="space-y-4" data-id="element-1527">
              <div className="flex items-start gap-4" data-id="element-1528">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-1529">
                  <CheckCircle className="w-5 h-5 text-[#0A5F8F]" data-id="element-1530" />
                </div>
                <div data-id="element-1531">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-1532">אישור במייל</h4>
                  <p className="text-gray-600" data-id="element-1533">
                    קיבלת אישור הרשמה למייל עם כל הפרטים החשובים
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-1534">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-1535">
                  <CheckCircle className="w-5 h-5 text-[#0A5F8F]" data-id="element-1536" />
                </div>
                <div data-id="element-1537">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-1538">
                    הצטרף לקבוצת הווטסאפ
                  </h4>
                  <p className="text-gray-600 mb-2" data-id="element-1539">
                    הצטרף לקבוצת הווטסאפ השקטה של הפסטיבל לעדכונים
                  </p>
                  <a href="https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA" target="_blank" rel="noopener noreferrer" className="text-[#0A5F8F] hover:underline font-semibold inline-flex items-center gap-2" data-id="element-1540">
                    לחץ כאן להצטרפות
                    <ExternalLink className="w-4 h-4" data-id="element-1541" />
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-1542">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-1543">
                  <Calendar className="w-5 h-5 text-[#0A5F8F]" data-id="element-1544" />
                </div>
                <div data-id="element-1545">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-1546">סמן ביומן</h4>
                  <p className="text-gray-600" data-id="element-1547">
                    12-14 במרץ 2026 | חוף מעגן עדן, כנרת
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Back to Home Button */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-1548">
            <Button onClick={() => navigate('/water-tribe-fest')} variant="outline" className="inline-flex items-center gap-2" data-id="element-1549">
              <Home className="w-5 h-5" data-id="element-1550" />
              חזרה לדף הפסטיבל
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <Footer data-id="element-1551" />
    </div>;
}